import $ from 'jquery';
import _ from 'underscore';
import Backbone from 'backbone';
import Constants from 'root/constants.js';
import Cache from 'root/cache';
import Router from 'root/router';
import UI from 'root/ui';
import PDF_JS from 'root/module/pdfjs';

import * as Sentry from "@sentry/browser";

import Model_Account from 'model/account';
import Model_Statistics from 'model/statistics';
import Model_Portal_User from 'model/portal_user';

import Collection_Integration_Slack from 'collection/integration_slack';
import Collection_Integration_Teams from 'collection/integration_teams';
import Collection_Integration_Jira from 'collection/integration_jira';
import Collection_Integration_Teamwork from 'collection/integration_teamwork';
import Collection_Integration_Trello from 'collection/integration_trello';
import Collection_Integration_Basecamp from 'collection/integration_basecamp';
import Collection_Integration_Github from 'collection/integration_github';
import Collection_Integration_Gitlab from 'collection/integration_gitlab';
import Collection_Integration_Linear from 'collection/integration_linear';
import Collection_Integration_Intercom from 'collection/integration_intercom';
import Collection_Integration_Asana from 'collection/integration_asana';
import Collection_Integration_Clickup from 'collection/integration_clickup';
import Collection_Integration_Wrike from 'collection/integration_wrike';
import Collection_Integration_Azure_Devops from 'collection/integration_azure_devops';
import Collection_Integration_Monday from 'collection/integration_monday';
import Collection_Integration_Notion from 'collection/integration_notion';
import Collection_Integration_Zendesk from 'collection/integration_zendesk';
import Collection_Integration_Webhook from 'collection/integration_webhook';

import Collection_Connected_App_Oauth  from 'collection/connected_app/oauth';
import Collection_Connected_App_Jira   from 'collection/connected_app/jira';
import Collection_Connected_App_Trello from 'collection/connected_app/trello';
import Collection_Connected_App_Teamwork from 'collection/connected_app/teamwork';
import Collection_Connected_App_Monday from 'collection/connected_app/monday';

import Collection_Menu from 'collection/menu';
import Collection_Inbox_Notification from 'collection/inbox_notification';
import Collection_Feedback from 'collection/feedback';
import Collection_Feedback_Screenshot from 'collection/feedback_screenshot';
import Collection_Feedback_Category from 'collection/feedback_category';
import Collection_Feedback_Comment from 'collection/feedback_comment';
import Collection_Feedback_Watch_List from 'collection/feedback_watch_list';
import Collection_Feedback_Annotation from 'collection/feedback_annotation';
import Collection_Feedback_Approver from 'collection/feedback_approver';
import Collection_Feedback_Console_Log from 'collection/feedback_console_log';
import Collection_Feedback_Network_log from 'collection/feedback_network_log';
import Collection_Feedback_Event_Track from 'collection/feedback_event_track';
import Collection_Feedback_Confirmation from 'collection/feedback_confirmation';
import Collection_Feedback_Autoreply from 'collection/feedback_autoreply';
import Collection_Feedback_Comment_Template from 'collection/feedback_comment_template';
import Collection_Session_Recording from 'collection/session_recording';
import Collection_Session_Recording_Rule from 'collection/session_recording_rule';
import Collection_Branding from 'collection/branding';
import Collection_Workspace from 'collection/workspace';
import Collection_Workspace_Member from 'collection/workspace_member';
import Collection_User from 'collection/user';
import Collection_User_Setting from 'collection/user_setting';
import Collection_User_Invitation from 'collection/user_invitation';
import Collection_User_Identification from 'collection/user_identification';
import Collection_User_Segment from 'collection/user_segment';
import Collection_Project from 'collection/project';
import Collection_Project_Domain from 'collection/project_domain';
import Collection_Project_Access from 'collection/project_access';
import Collection_Project_Recording_Rule from 'collection/project_recording_rule';
import Collection_Workflow from 'collection/workflow';
import Collection_Portal from 'collection/portal';
import Collection_Portal_Announcement from 'collection/portal_announcement';
import Collection_Portal_Status from 'collection/portal_status';
import Collection_Survey from 'collection/survey';
import Collection_Survey_Question from 'collection/survey_question';
import Collection_Survey_Response from 'collection/survey_response';
import Collection_Widget from 'collection/widget';
import Collection_Widget_Setting from 'collection/widget_setting';
import Collection_Widget_Trigger_Code from 'collection/widget_trigger_code';
import Collection_Api_Token from 'collection/api_token';
import Collection_Extension_Key from 'collection/extension_key';
import Collection_Invoice from 'collection/invoice';
import Collection_Referral_Invoice from 'collection/referral_invoice';
import Collection_Notification from 'collection/notification';
import Collection_Integration_Log from 'collection/integration_log';

import mixpanel from 'mixpanel-browser';

import Intercom, { update as IntercomUpdate, trackEvent as IntercomTrackEvent } from "@intercom/messenger-js-sdk";

import Cookie from 'root/lib/cookie';

var App = function() {
    // public
    this.debug = false;

    this.dispatcher = _.extend({}, Backbone.Events);

    this.cached_response = {};

    this.init = function(options) {
        // requirejs hack
        Cache.app = this;

        // public options
        this.debug = !!options.debug;
        this.host  = options.host;

        this.configs = {};

        // debug
        if (this.debug) {
            window._Userback = {
                Cache: Cache,
                UI: UI,
                App: this
            };
        }

        // bind routes
        this.bindRoutes();

        // load init app data
        var action = 'app/getData';
        var data   = {};

        if (this.isFeedbackViewer()) {
            action = 'app/getViewerData';
        } else if (this.isFeedbackPortal()) {
            var url_fragment = window.location.pathname.split('/');

            if (url_fragment.length === 3 && url_fragment[url_fragment.length - 1] === '404') {
                action = '';
            } else {
                action = 'app/getPortalData';
            }

        } else if (this.isExtCapture() || this.isSessionReplayShare()) {
            action = '';

            // call setData for the models/collections to be created
            this.setData({});
        }

        if (action) {
            // fetch app data and build UI
            this.request({
                action: action,
                data: data,
                success: function(response) {
                    // data
                    this.setData(response);

                    // configs
                    this.configs = response.configs;

                    if (!this.isPublicPage()) {
                        setTimeout(() => {
                            this.renewSession();
                        }, 3 * 60 * 1000);  // renew every 3 mins
                    }

                    // identify user on log in success
                    this.identifyUser();
                    this.intercomSync();

                    Cache.project.on('add remove',        this.identifyUser.bind(this));
                    Cache.project_domain.on('add remove', this.identifyUser.bind(this));
                    Cache.account.on('change:onboarding', this.identifyUser.bind(this));
                },
                complete: function() {
                    $('#xhr-loading-status').remove();
                    Backbone.history.start({pushState: true});
                }
            });


            PDF_JS.init();
            UI.init();
        } else {
            UI.init();
            Backbone.history.start({pushState: true});
        }

        this.addExternalScript();
    };

    this.bindRoutes = function() {
        // setup router
        Router.on('route:index', function(index, splat, query) {
            // reset selected project when navigating to different pages, and select/load the project if it changes
            var last_selected_project_id = Cache.default_project_id;
            var load_selected_project = false;
            Cache.default_project_id = 0;

            if (index === 'viewer') {
                Cache.default_project_id = Cache.project && Cache.project.length ? Cache.project.at(0).id : 0;

                // build feedback viewer when account model is set (account model is only set when authenticated)
                if (Cache.current_page && Cache.current_page === 'viewer') {
                    // when pressing browser back button
                    UI.views.page.load();
                } else {
                    // refresh or init page hit
                    if (Cache.account) {
                        UI.buildPage('viewer');
                    } else {
                        UI.buildPage('viewer', {not_found: true});
                    }
                }
            } else if (index === 'sr') {
                // public page
                UI.buildPage('sr', {
                    share_key: splat.replace(/\/$/, '') // remove trailing slash
                });
            } else if (index === 'p') {
                Cache.default_project_id = Cache.portal && Cache.portal.length ? Cache.portal.at(0).get('project_id') : 0;

                // public page
                // don't rebuild the portal page when url changes from /p/xxxxxx to /p/xxxxxx/ideas/123456
                UI.buildPage('portal');
            } else if (index === 'capture') {
                // public page
                UI.buildPage('capture');
            } else {
                if (Cache.app.isProjectPage(index) && Cache.project) {
                    // old project pages links look up the last project cookie or get sent to the first project
                    var project = null;
                    if (Cookie.hasItem('lpk') && Cookie.getItem('lpk')) {
                        project = Cache.project.where({project_key: Cookie.getItem('lpk')});
                    }
                    if (!project || !project.length) {
                        project = Cache.project.where({is_archived: false});
                    }

                    if (project.length) {
                        window.location = '/' + project[0].get('project_key') + '/' + index + '/' + (splat ? splat : '') + (query ? '?' + query : '');
                    } else {
                        window.location = '/project/';
                    }
                    return;
                }

                let project_page = splat ? splat.trim().replace(/\/$/, '') : '';
                let project_splat = '';
                let project_slash_index = project_page.indexOf('/');

                // handle additional fragments such as feedback/design
                if (project_slash_index >= 0) {
                    project_splat = project_page.substring(project_slash_index + 1);
                    project_page = project_page.substring(0, project_slash_index).trim();
                }

                if (Cache.app.isProjectPage(project_page) && Cache.project) {
                    var project_key = index.toUpperCase();
                    index = project_page;
                    splat = project_splat;

                    var project = Cache.project.findWhere({project_key: project_key});
                    if (project) {
                        if (last_selected_project_id !== project.id) {
                            // If the page we're loading has a different project id, load the project data again:
                            load_selected_project = true;
                        }
                        Cache.default_project_id = project.id;
                    } else {
                        // project id not found in project collection
                        index = '404';
                    }
                }

                let page_options;

                if (!Router.checkAccess(false, index) && index !== 'login') {
                    index = 'login';
                }

                // wrong url: /portal/something/
                if (index === 'portal') {
                    index = '404';
                }

                var menu_access = Cache.app.getMenuAccess();
                if (index !== 'login' && index !== 'portal' && menu_access.length && menu_access.indexOf('/' + index + '/') === -1) {
                    if (index !== null && window.location.pathname !== '/') {
                        index = '404';
                    } else {
                        // default page
                        // "trigger: false" so that URL will change but the page will be built by the code down below
                        index = 'project';
                        Router.navigate('/project/', {trigger: false});
                    }
                }

                if (index === 'account') {
                    if (splat === 'billing') {
                        index = 'billing';
                    } else if (splat === 'referral') {
                        index = 'referral';
                    } else if (splat === 'api_token') {
                        index = 'api_token';
                    } else if (splat === 'connected_app') {
                        index = 'connected_app';
                    } else if (splat === 'extension_key') {
                        index = 'extension_key';
                    } else if (splat === 'branding') {
                        index = 'branding';
                    } else if (splat === 'integration_log') {
                        index = 'integration_log';
                    }
                } else if (index === 'feedback') {
                    if (splat === 'design' || splat === 'design/') {
                        index = 'feedback_design';
                        page_options = {is_design: true};
                    } else {
                        index = 'feedback';
                        page_options = {is_design: false};
                    }
                }

                if (load_selected_project) {
                    UI.buildPage('loading');
                    Cache.app.selectProject(Cache.default_project_id, () => {
                        UI.buildPage(index, page_options);
                    });
                } else {
                    UI.buildPage(index, page_options);
                }
            }
        });

        Router.on('route:signUpReferral', function(code) {
            UI.buildPage('login', {signup: true, referral_code: code});
        });

        Router.on('route:signUp', function(code) {
            UI.buildPage('login', {signup: true});
        });

        Router.on('route:workspaceSelect', function(code) {
            UI.buildPage('login', {workspace_select: true});
        });

        Router.on('route:forgotPassword', function() {
            UI.buildPage('login', {forgot_password: true});
        });

        Router.on('route:resetPassword', function(key) {
            UI.buildPage('login', {reset_password: true, password_reset_key: key});
        });

        Router.on('route:userInvitation', function(key) {
            UI.buildPage('login', {user_invitation: true, invitation_key: key});
        });

        Router.on('route:joinWorkspace', function(code) {
            UI.buildPage('login', {join: true, join_code: code});
        });

        Router.on('route:portalRoadmap', function(key, id) {
            UI.buildPage('portal', {
                roadmap: true,
                feedback_id: id
            });
        });

        Router.on('route:portalAnnouncement', function(key, id) {
            UI.buildPage('portal', {
                announcement: true,
            });
        });

        Router.on('route:portalViewFeedback', function(key, id) {
            UI.buildPage('portal', {
                feedback_id: id
            });
        });

        Router.on('route:portalResetPassword', function(key, id) {
            UI.buildPage('portal', {
                password_reset_key: id
            });
        });
    };

    this.getMenuAccess = function() {
        // Always available
        const menu_items = [
            '/404/',
            '/login/'
        ];

        if (Cache.user) {
            menu_items.push(
                '/setup/',
                '/project/',
                '/member/',
                '/inbox/',
                '/viewer/',
                '/sr/',
                '/capture/',
                '/dashboard/',
                '/feedback/',
                '/feedback/design',
                '/response/',
                '/integration/',
                '/style_guide/'
            );

            if (Cache.workspace_member) {
                if (Cache.getRealWorkspaceMember() && Cache.getRealWorkspaceMember().get('role') !== Constants.CLIENT) {
                    menu_items.push(
                        '/plan/',
                        '/demo/',
                        '/portal/',
                        '/user_segment/'
                    );

                    if(Cache.app.checkRoleAccess(Constants.ACCESS_SESSION_REPLAY, Cache.getRealWorkspaceMember().get('role'))) {
                        menu_items.push('/session_replay/');
                    }
                }

                if (Cache.getRealWorkspaceMember() && Cache.getRealWorkspaceMember().get('role') === Constants.ADMIN) {
                    menu_items.push(
                        '/account/',
                        '/settings/'
                    );
                }

                if (Cache.app.isSuperAdmin()) {
                    menu_items.push(
                        '/admin/'
                    );
                }
            }
        }

        return menu_items;
    }

    this.identifyUser = function() {
        if (!this.external_scripts_added) {
            return false;
        }

        if (!Cache.real_user_id) {
            return;
        }

        try {
            // Userback
            if (typeof Userback !== 'undefined' && typeof Userback.identify === 'function') {
                Userback.identify(Cache.real_user_id, this.getUserDdData());
            }

            // Mixpanel
            if (typeof mixpanel !== 'undefined') {
                mixpanel.identify(Cache.real_user_id);
            }

            // Sentry
            if (typeof Sentry !== 'undefined' && typeof Sentry.setUser === 'function') {
                Sentry.setUser({
                    id: Cache.real_user_id,
                    account_id: Cache.account.id
                });
            }
        } catch (e) {
            // ignore errors from third-party tools
        }
    };

    this.addExternalScript = function() {
        // Userback
        if (
            !this.debug &&
            !this.isPublicPage() &&
            !this.isDemoPage()
        ) {
            // Userback
            window.Userback = window.Userback || {};
            Userback.access_token = 'A-IjXmeq4nrQRoPlmr84Tm7x2dDZUdpW08fYuuoyRQpIef3AHcFB';
            Userback.on_load = () => {
                if (Cache.real_user_id) {
                    Userback.identify(Cache.real_user_id, this.getUserDdData());
                }
            };

            (function(d) {
                var s = d.createElement('script');s.async = true;
                s.src = 'https://static.userback.io/widget/v1.js';
                (d.head || d.body).appendChild(s);
            })(document);

            // Mixpanel
            if (!Cache.app.is_admin_login) {
                mixpanel.init('8c0a87f885982cb2b832c40f4b9e2244', {debug: false, api_host: 'https://mp.userback.io'});

                if (Cache.real_user_id) {
                    mixpanel.identify(Cache.real_user_id);
                }
            }

            // Sentry
            Sentry.init({
                dsn: 'https://56952749a1d241159f5c0782f3494b99@o268844.ingest.us.sentry.io/1476900',
                ignoreErrors: ['TypeError: Failed to fetch']
            });

            if (Cache.real_user_id) {
                Sentry.setUser({
                    id: Cache.real_user_id,
                    account_id: Cache.account.id
                });
            }

            this.external_scripts_added = true;
        }
    };

    // intercom
    this.intercomSync = function() {
        if (!this.trackIntercom()) {
            return;
        }

        var intercom_data = this.getIntercomDataAttributes();

        if (this.intercom_is_booted) {
            IntercomUpdate(intercom_data);
        } else {
            Intercom(intercom_data);
            this.intercom_is_booted = true;

            Cache.account.on('change', this.intercomSync.bind(this));
            Cache.getRealUser().on('change', this.intercomSync.bind(this));
            Cache.project.on('add remove', this.intercomSync.bind(this));
            Cache.user.on('add remove', this.intercomSync.bind(this));
            Cache.portal.on('add remove', this.intercomSync.bind(this));
        }
    }

    this.trackIntercom = function() {
        return Cache.real_user_id && !Cache.app.is_admin_login &&
        !this.isFeedbackViewer() && !this.isFeedbackPortal() && !this.isExtCapture() &&
        /*!Cache.account.get('appsumo') && */ !this.isClient() && this.isIntercomAvailable();
    };

    this.getIntercomCompanyAttributes = function() {
        var account_id            = Cache.account.id;
        var account_onboarding    = Cache.account.get('onboarding');
        var response_limit        = Cache.account.getResponseLimit();
        var session_limit         = Cache.account.get('session_limit');
        var account_usage         = Cache.account.getUsage();
        var total_responses_usage = account_usage.feedback + account_usage.survey_response;
        var total_sessions_usage  = account_usage.session_recording;
        var total_user_segments   = Cache.user_segment.length;
        var response_usage_percentage = response_limit ?  `${Math.round((total_responses_usage/response_limit) * 100)}%` : 0;
        var session_usage_percentage  = session_limit ? `${Math.round((total_sessions_usage/session_limit) * 100)}%` : 0;
        var monthly_spend = Cache.account.getPrice(Cache.account.get('plan'), Cache.account.get('billing_interval'), Cache.account.get('project_limit'), Cache.account.get('extra_user'), Cache.account.get('session_limit'), Cache.account.get('response_limit'));

        var company = {
            // intercom built-in data
            id                        : account_id,
            name                      : Cache.account.get('company'),
            created_at                : Cache.account.get('join_time'),
            plan                      : Cache.account.getPlanName(),
            monthly_spend             : monthly_spend,
            // custom data attributes
            upgraded_at               : Cache.account.get('upgrade_time'),
            billing_cycle             : Cache.account.getBillingCycle(),
            billing_email             : Cache.account.get('billing_email'),
            annual_spend              : monthly_spend * 12,
            is_deleted                : Cache.account.get('is_deleted') ? 'Yes' : 'No',
            has_card_on_file          : Cache.account.get('credit_card_digit') ? 'Yes' : 'No',
            is_appsumo                : Cache.account.get('appsumo') ? 'Yes' : 'No',
            is_expired                : Cache.account.get('is_expired') ? 'Yes' : 'No',
            is_trial_account          : Cache.account.get('is_trial') ? 'Yes' : 'No',
            is_overdue                : Cache.account.get('overdue_days') > 0 ? 'Yes' : 'No',
            referral_code             : Cache.account.get('referral_code'),
            referred_by               : Cache.account.get('referred_by'),
            total_responses           : total_responses_usage,
            response_limit            : response_limit,
            response_usage_percentage : response_usage_percentage,
            total_user_segments       : total_user_segments,
            total_sessions            : total_sessions_usage,
            session_limit             : session_limit,
            session_usage_percentage  : session_usage_percentage,
            total_users               : Cache.workspace_member.where({is_disabled: false}).length,
            total_idea_portals        : Cache.portal.length,
            total_survey_responses    : account_usage.survey_response,
            total_feedback_responses  : account_usage.feedback,
            total_feedback_projects   : Cache.project.where({project_type: 'feedback'}).length,
            total_survey_projects     : Cache.project.where({project_type: 'survey'}).length,
            total_projects_active     : Cache.project.where({is_archived: false}).length,
            total_projects_archived   : Cache.project.where({is_archived: true}).length,
            trial_expiry_date         : Cache.account.get('trial_expiry_date'),
            usage_reset_date          : Cache.account.getUsageResetDate(),
            code_installed            : account_onboarding.widget_install ? 'Yes' : 'No',
            widget_customized         : account_onboarding.widget_edit ? 'Yes' : 'No',
            workflow_customized       : account_onboarding.workflow_edit ? 'Yes' : 'No',
            use_case                  : Cache.account.get('use_case')
        };

        Object.keys(company).forEach((key) => {
            var value = company[key];

            if (value === '') {
                company[key] = '-';
            }
        });

        return company;
    };

    this.getIntercomDataAttributes = function() {
        var intercom_config    = this.configs.intercom_config;
        var [intercom_app_id, intercom_user_hash] = intercom_config ? intercom_config.split('_') : [];

        var logged_in_user   = Cache.getRealUser();
        var workspace_member = Cache.getRealWorkspaceMember();
        var user_id          = logged_in_user.id;
        var account_id       = Cache.account.id;
        var company          = this.getIntercomCompanyAttributes();

        return {
            app_id                : intercom_app_id,
            user_hash             : intercom_user_hash,
            hide_default_launcher : true,
            user_id               : `${account_id}-${user_id}`,
            name                  : logged_in_user.get('name'),
            email                 : logged_in_user.get('email'),
            email_confirmed_status: logged_in_user.get('is_email_confirmed') ? 'Yes': 'No',
            job_title             : logged_in_user.get('job'),
            is_owner              : workspace_member.get('is_owner') ? 'Yes' : 'No',
            role                  : workspace_member.getRoleName(),
            company               : company
        };
    };

    this.isIntercomAvailable = function() {
        var intercom_data = this.getIntercomDataAttributes();

        return !!intercom_data.app_id;
    };

    this.trackEvent = function(event_name, options, identify) {
        if (this.debug || this.isPublicPage() || this.isDemoPage() || Cache.app.is_admin_login) {
            return;
        }

        // mixpanel
        try {
            if (typeof mixpanel === 'object') {
                switch (event_name) {
                    case 'pageview':
                        // mixpanel.track_pageview();
                        break;
                    case 'logout':
                        mixpanel.reset();
                        break;
                    default:
                        if (identify === true) {
                            mixpanel.identify(Cache.real_user_id);
                        }
                        if (typeof options !== 'object') {
                            options = {};
                        }
                        options.account = 'account_' + Cache.account.id;
                        options.plan = Cache.account.getPlanName();
                        options.is_trial_account = Cache.account.get('is_trial')   ? 'Yes' : 'No';
                        options.is_expired = Cache.account.get('is_expired') ? 'Yes' : 'No';

                        mixpanel.track(event_name, options);
                        break;
                }
            }
        } catch (e) {
            if (this.debug) {
                console.log(e);
            }
        }

        // intercom
        try {
            if (this.intercom_is_booted) {
                if (event_name === 'pageview' ||
                    event_name === 'logout'
                ) {
                    // ignore
                } else {
                    IntercomTrackEvent(event_name, options);
                }
            }
        } catch (e) {
            if (this.debug) {
                console.log(e);
            }
        }
    };

    // user data to be identified in Userback widget
    this.getUserDdData = function() {
        const account_usage = Cache.account.getUsage();
        return {
            account_id             : Cache.account.id,
            account_type           : Cache.account.getPlanName(),
            email                  : Cache.getRealUser().get('email'),
            name                   : Cache.getRealUser().get('name'),
            appsumo                : Cache.account.get('appsumo')    ? 'Yes' : 'No',
            trial                  : Cache.account.get('is_trial')   ? 'Yes' : 'No',
            is_expired             : Cache.account.get('is_expired') ? 'Yes' : 'No',
            project_total          : Cache.project.length,
            project_feedback_total : Cache.project.where({project_type: 'feedback'}).length,
            project_survey_total   : Cache.project.where({project_type: 'survey'}).length,
            usage_session_total    : account_usage.session_recording,
            usage_feedback_total   : account_usage.feedback,
            usage_survey_total     : account_usage.survey_response,
            usage_response_total   : account_usage.feedback + account_usage.survey_response,
            domain_total           : Cache.project_domain.length,
            code_installed         : Cache.account.get('onboarding').widget_install ? 'Yes' : 'No'
        };
    };

    this.renewSession = function() {
        this.request({
            action: 'app/idle',
            success: (response) => {
                if (response && response.app_version) {
                    if (this.app_version && this.app_version !== response.app_version) {
                        this.app_requires_refresh = true;

                        UI.success('A new version of the app is available!', 1000000, false, {text: 'Refresh', onclick: () => {
                            window.location.reload();
                        }});
                    }

                    this.app_version = response.app_version;
                }

                setTimeout(this.renewSession.bind(this), 3 * 60 * 1000);  // renew every 3 mins
            },
            error: () => {
                // provide an empty error() to ignore the system generated error message
            }
        });
    };

    // set all the data in Cache: use this to reload the entire app
    this.setData = function(data) {
        var data_hash = {
            account: {
                type: 'model',
                constructor: Model_Account
            },
            workspace: {
                type: 'collection',
                constructor: Collection_Workspace
            },
            workspace_member: {
                type: 'collection',
                constructor: Collection_Workspace_Member
            },
            api_token: {
                type: 'collection',
                constructor: Collection_Api_Token
            },
            extension_key: {
                type: 'collection',
                constructor: Collection_Extension_Key
            },
            branding: {
                type: 'collection',
                constructor: Collection_Branding
            },
            user: {
                type: 'collection',
                constructor: Collection_User
            },
            user_setting: {
                type: 'collection',
                constructor: Collection_User_Setting
            },
            user_invitation: {
                type: 'collection',
                constructor: Collection_User_Invitation
            },
            user_identification: {
                type: 'collection',
                constructor: Collection_User_Identification,
            },
            user_segment: {
                type: 'collection',
                constructor: Collection_User_Segment,
            },
            project: {
                type: 'collection',
                constructor: Collection_Project
            },
            project_domain: {
                type: 'collection',
                constructor: Collection_Project_Domain
            },
            project_access: {
                type: 'collection',
                constructor: Collection_Project_Access
            },
            project_recording_rule: {
                type: 'collection',
                constructor: Collection_Project_Recording_Rule
            },
            workflow: {
                type: 'collection',
                constructor: Collection_Workflow
            },
            invoice: {
                type: 'collection',
                constructor: Collection_Invoice
            },
            referral_invoice: {
                type: 'collection',
                constructor: Collection_Referral_Invoice
            },
            notification: {
                type: 'collection',
                constructor: Collection_Notification
            },
            portal: {
                type: 'collection',
                constructor: Collection_Portal
            },
            portal_announcement: {
                type: 'collection',
                constructor: Collection_Portal_Announcement
            },
            portal_status: {
                type: 'collection',
                constructor: Collection_Portal_Status
            },
            survey: {
                type: 'collection',
                constructor: Collection_Survey
            },
            survey_question: {
                type: 'collection',
                constructor: Collection_Survey_Question
            },
            survey_response: {
                type: 'collection',
                constructor: Collection_Survey_Response
            },
            widget:{
                type: 'collection',
                constructor: Collection_Widget
            },
            widget_setting:{
                type: 'collection',
                constructor: Collection_Widget_Setting
            },
            widget_trigger_code:{
                type: 'collection',
                constructor: Collection_Widget_Trigger_Code
            },
            statistics: {
                type: 'model',
                constructor: Model_Statistics
            },
            integration_slack: {
                type: 'collection',
                constructor: Collection_Integration_Slack
            },
            integration_teams: {
                type: 'collection',
                constructor: Collection_Integration_Teams
            },
            integration_jira: {
                type: 'collection',
                constructor: Collection_Integration_Jira
            },
            integration_teamwork: {
                type: 'collection',
                constructor: Collection_Integration_Teamwork
            },
            integration_trello: {
                type: 'collection',
                constructor: Collection_Integration_Trello
            },
            integration_basecamp: {
                type: 'collection',
                constructor: Collection_Integration_Basecamp
            },
            integration_github: {
                type: 'collection',
                constructor: Collection_Integration_Github
            },
            integration_gitlab: {
                type: 'collection',
                constructor: Collection_Integration_Gitlab
            },
            integration_linear: {
                type: 'collection',
                constructor: Collection_Integration_Linear
            },
            integration_intercom: {
                type: 'collection',
                constructor: Collection_Integration_Intercom
            },
            integration_asana: {
                type: 'collection',
                constructor: Collection_Integration_Asana
            },
            integration_clickup: {
                type: 'collection',
                constructor: Collection_Integration_Clickup
            },
            integration_wrike: {
                type: 'collection',
                constructor: Collection_Integration_Wrike
            },
            integration_azure_devops: {
                type: 'collection',
                constructor: Collection_Integration_Azure_Devops
            },
            integration_monday: {
                type: 'collection',
                constructor: Collection_Integration_Monday
            },
            integration_zendesk: {
                type: 'collection',
                constructor: Collection_Integration_Zendesk
            },
            integration_webhook: {
                type: 'collection',
                constructor: Collection_Integration_Webhook
            },
            integration_notion: {
                type: 'collection',
                constructor: Collection_Integration_Notion
            },
            connected_app_oauth: {
                type: 'collection',
                constructor: Collection_Connected_App_Oauth
            },
            connected_app_jira: {
                type: 'collection',
                constructor: Collection_Connected_App_Jira
            },
            connected_app_trello: {
                type: 'collection',
                constructor: Collection_Connected_App_Trello
            },
            connected_app_teamwork: {
                type: 'collection',
                constructor: Collection_Connected_App_Teamwork
            },
            connected_app_monday: {
                type: 'collection',
                constructor: Collection_Connected_App_Monday
            },
            menu: {
                type: 'collection',
                constructor: Collection_Menu
            },
            inbox_notification: {
                type: 'collection',
                constructor: Collection_Inbox_Notification
            },
            feedback: {
                type: 'collection',
                constructor: Collection_Feedback
            },
            feedback_category: {
                type: 'collection',
                constructor: Collection_Feedback_Category
            },
            feedback_screenshot: {
                type: 'collection',
                constructor: Collection_Feedback_Screenshot
            },
            feedback_comment: {
                type: 'collection',
                constructor: Collection_Feedback_Comment
            },
            feedback_watch_list: {
                type: 'collection',
                constructor: Collection_Feedback_Watch_List
            },
            feedback_annotation: {
                type: 'collection',
                constructor: Collection_Feedback_Annotation
            },
            feedback_approver: {
                type: 'collection',
                constructor: Collection_Feedback_Approver
            },
            feedback_console_log: {
                type: 'collection',
                constructor: Collection_Feedback_Console_Log
            },
            feedback_network_log: {
                type: 'collection',
                constructor: Collection_Feedback_Network_log,
            },
            feedback_event_track: {
                type: 'collection',
                constructor: Collection_Feedback_Event_Track
            },
            feedback_confirmation: {
                type: 'collection',
                constructor: Collection_Feedback_Confirmation,
            },
            feedback_autoreply: {
                type: 'collection',
                constructor: Collection_Feedback_Autoreply,
            },
            feedback_comment_template: {
                type: 'collection',
                constructor: Collection_Feedback_Comment_Template,
            },
            feedback_count: {
                type: 'object'
            },
            feedback_unsubscribed_emails: {
                type: 'object',
            },
            session_recording: {
                type: 'collection',
                constructor: Collection_Session_Recording
            },
            session_recording_rule: {
                type: 'collection',
                constructor: Collection_Session_Recording_Rule
            },
            integration_log: {
                type: 'collection',
                constructor: Collection_Integration_Log
            },
        };

        // create/reset model/collection from data
        _.each(data, function(json, name) {
            if (data_hash[name]) {
                if (Cache[name]) {
                    if (data_hash[name].type === 'model') {
                        if (json === null) {
                            Cache[name].set(Cache[name].defaults);
                        } else {
                            Cache[name].set(json);
                        }
                    } else if (data_hash[name].type === 'collection') {
                        Cache[name].reset(json);
                    } else if (data_hash[name].type === 'object') {
                        Cache[name] = json;
                    }
                } else {
                    if (data_hash[name].type === 'object') {
                        Cache[name] = json;
                    } else {
                        Cache[name] = new data_hash[name].constructor(json);
                    }
                }
            }
        });

        // create empty model or collection when data doesn't contain the key
        _.each(data_hash, function(object, name) {
            if (!Cache[name]) {
                Cache[name] = new object.constructor();
            }
        });

        if (data.portal_user) {
            Cache.portal_user = new Model_Portal_User(data.portal_user);
        }

        if (data.session) {
            if (data.session.user_id) {
                Cache.real_user_id = data.session.user_id;
            } else if (data.session.guest_email && data.session.guest_name) {
                Cache.setGuestUser(data.session.guest_email, data.session.guest_name, data.session.guest_avatar, data.session.guest_type);
            }

            if (data.session.default_workspace_id) {
                Cache.default_workspace_id = data.session.default_workspace_id;
            }

            if (data.session.is_admin_login) {
                this.is_admin_login = true;
            }

            if (data.session.workspace_roles) {
                this.workspace_roles = data.session.workspace_roles;
            }
        }

        if (data.user_properties) {
            Cache.user_properties = data.user_properties;
        }
    };

    this.setDefaultWorkspace = function(workspace_id, callback) {
        this.request({
            action: 'app/setDefaultWorkspace',
            context: this,
            data: {
                id: workspace_id,
            },
            success: () => {
                if (callback) {
                    callback();
                }
            }
        });
    },

    this.selectProject = function(project_id, callback) {
        var _change = () => {
            this.request({
                action: 'app/getProject',
                data: {
                    id: project_id,
                },
                success: (response) => {
                    Cache.default_project_id = response.project_id;

                    this.setData(response);
                    this.dispatcher.trigger('update:Cache:default_project_id');

                    // force refresh history so the router event will be triggered when page url doesn't change

                    // TODO:
                    // this breaks - it calls the router again and makes additional http requests for the OLD url
                    // do we even need to do this anymore given that when we change projects we change the url? or can it just be removed?

                    // Backbone.history.loadUrl(Backbone.history.fragment);

                    if (callback) {
                        callback();
                    }
                }
            });
        };

        if (UI.onPageUnload('onBeforeProjectChange', null, _change)) {
            _change();
        }
    };

    this.getProjectOnboarding = function(event_name, project_id) {
        if (typeof project_id === 'undefined') {
            project_id = Cache.default_project_id;
        }

        var onboarding = Cache.account.get('project_onboarding')[project_id];

        if (onboarding && onboarding[event_name]) {
            return onboarding[event_name].event_val;
        }

        return null;
    },

    this.trackProjectOnboarding = function(name, event_val, project_id) {
        if (Cache.app.is_admin_login) {
            return;
        }

        project_id = project_id || Cache.default_project_id;
        var onboarding = Cache.account.get('project_onboarding')[project_id];

        if (onboarding && onboarding[name]) {
            // use double == here because the value can be string or number
            if (onboarding[name].event_val == event_val) {
                return;
            }
        }

        this.request({
            action: 'account/trackProjectOnboarding',
            data:{
                project_id: project_id,
                event_name: name,
                event_val : event_val
            },
            success: (response) => {
                Cache.account.set('project_onboarding', response);
            }
        });
    };

    this.trackOnboarding = function(name, event_val) {
        var onboarding = Cache.account.get('onboarding');

        if (onboarding[name]) {
            if (typeof onboarding[name] === 'string' && onboarding[name] === event_val) {
                return;
            }

            if (Array.isArray(onboarding[name]) && onboarding[name].length && onboarding[name].indexOf(event_val) !== -1) {
                return;
            }
        }

        this.request({
            action: 'account/trackOnboarding',
            data:{
                event_name: name,
                event_val : event_val
            },
            success: () => {
                var modification = {};

                modification[name] = event_val;

                if (name === 'help_articles') {
                    var value = onboarding.help_articles
                        ? _.uniq(onboarding.help_articles.concat(event_val))
                        : [event_val];

                    modification[name] = value;
                }

                Cache.account.set('onboarding', _.extend({}, onboarding, modification));
            }
        });
    }

    this.getUserSetting = function(setting_name, current_project) {
        if (!Cache.user_setting) {
            return null;
        }

        var search = {
            setting_name: setting_name
        };

        if (current_project) {
            search.project_id = Cache.default_project_id;
        }

        var setting_model = Cache.user_setting.findWhere(search);
        var setting_value = null;

        if (setting_model) {
            setting_value = setting_model.get('setting_value');

            if (setting_value === 'true') {
                setting_value = true;
            } else if (setting_value === 'false') {
                setting_value = false;
            }
        }

        return setting_value;
    };

    this.deleteUserSetting = function(setting_name, current_project) {
        var existing_setting = this.getUserSetting(setting_name, current_project);
        if (existing_setting === null) {
            return;
        }

        var data = {
            setting_name: setting_name
        };

        if (current_project) {
            data.project_id = Cache.default_project_id;
        }

        this.request({
            action: 'user_setting/delete',
            data: data
        });

        var existing_model = Cache.user_setting.findWhere(data);

        if (existing_model) {
            Cache.user_setting.remove(existing_model);
        }
    };

    this.addUserSetting = function(setting_name, setting_value, current_project) {
        var existing_setting = this.getUserSetting(setting_name, current_project);
        if (existing_setting == setting_value) {
            return;
        }

        var data = {
            setting_name  : setting_name,
            setting_value : setting_value
        };

        if (current_project) {
            data.project_id = Cache.default_project_id;
        }

        this.request({
            action: 'user_setting/add',
            data: data
        });

        // dont need to wait for xhr to come back
        var search = data;
        delete search.setting_value;

        var existing_model = Cache.user_setting.findWhere(search);

        if (existing_model) {
            Cache.user_setting.remove(existing_model);
        }

        Cache.user_setting.add({
            account_id    : Cache.account.id,
            user_id       : Cache.real_user_id,
            project_id    : current_project ? Cache.default_project_id : 0,
            setting_name  : setting_name,
            setting_value : setting_value
        });
    };

    // make XHR request
    this.request = function(options) {
        var data     = options.data     || {};
        var success  = options.success  || null;
        var complete = options.complete || null;
        var error    = options.error    || null;
        var context  = options.context  || this;
        var anon     = options.anon     || false;
        var cache    = options.cache    || 0;     // seconds
        var url      = options.url      || window.location.href;

        var project_key = Cache.project && Cache.getDefaultProject() ? Cache.getDefaultProject().get('project_key') : '';

        var post_data = $.extend({action: options.action, ct: window.app_configs.ct, pk: project_key}, data);
        var cache_key = JSON.stringify(post_data);

        if (!options.action) {
            UI.error('Error occured, please try again later');
            return;
        }

        if (url.indexOf('?') === -1) {
            url += '?_xhr=' + encodeURIComponent(options.action.replace('\/', '_'));
        } else {
            url += '&_xhr=' + encodeURIComponent(options.action.replace('\/', '_'));
        }

        if (cache && this.cached_response[cache_key]) {
            if (success) {
                success.call(context, this.cached_response[cache_key]);
            }

            if (complete) {
                complete.call(context);
            }

            return;
        }

        var xhr = $.ajax(url, {
            type     : 'POST',
            dataType : 'json',
            data     : post_data,
            context  : this,
            beforeSend: function(jqXHR, settings) {
            },
            success: function(data, textStatus, jqXHR) {
                var authenticated = this.checkAuthentication(data, jqXHR);

                if (data && data.error) {
                    if (error) {
                        error.call(context);
                    } else {
                        UI.error(data.error);
                    }
                } else if (data === false) {
                    // error handler
                    if (error) {
                        error.call(context);
                    } else {
                        UI.error('Error occured, please try again later');
                    }
                } else {
                    if (success && (authenticated || anon)) {
                        success.call(context, data);

                        if (cache) {
                            this.cached_response[cache_key] = data;
                            setTimeout(() => {
                                delete this.cached_response[cache_key];
                            }, cache * 1000);
                        }
                    }
                }
            },
            complete: function(jqXHR, textStatus) {
                if (complete) {
                    complete.call(context);
                }
            },
            error: function(jqXHR, textStatus, errorThrown) {
                if (error) {
                    error.call(context);
                } else if (textStatus !== 'abort') {
                    if (this.debug) {
                        let div = $('<div>');

                        div.html(jqXHR.responseText);

                        $('#app').append(div);
                    }
                    UI.error('System error, please try again later');
                }
            }
        });

        return xhr;
    };

    this.getJson = function(options) {
        var context  = options.context || this;

        var xhr = $.ajax(options.url, {
            type     : 'GET',
            dataType : 'json',
            context  : context,
            beforeSend: function(jqXHR, settings) {
            },
            success: function(data, textStatus, jqXHR) {
                options.success.call(context, data);
            },
            complete: function(jqXHR, textStatus) {

            },
            error: function(jqXHR, textStatus, errorThrown) {

            }
        });

        return xhr;
    };

    // check authetication in XHR response
    this.checkAuthentication = function(data, jqXHR) {
        var device_limit = jqXHR && jqXHR.getResponseHeader('x-device-limit') > 0;
        if (data && data.authenticated === false) {
            if (window.location.pathname !== '/login/' && !this.isFeedbackPortal()) {
                Router.navigate('/login/' + (device_limit ? '?ec=device_limit' : ''), {trigger: true});
            }

            return false;
        }

        return true;
    };

    // is the logged in user an admin of the workspace
    this.isWorkspaceAdmin = function(workspace_id) {
        return this.workspace_roles[workspace_id] && this.workspace_roles[workspace_id].role === Constants.ADMIN ? true : false;
    },

    // is the logged in user the owner of the current workspace
    this.isWorkspaceOwner = function(workspace_id) {
        return this.workspace_roles[workspace_id] && this.workspace_roles[workspace_id].is_owner ? true : false;
    };

    // is the logged in user the owner of the current workspace
    this.isOwner = function() {
        return Cache.getRealWorkspaceMember() && Cache.getRealWorkspaceMember().get('is_owner') ? true : false;
    };

    // is the logged in user an admin of the current workspace
    this.isAdmin = function() {
        return Cache.getRealWorkspaceMember() && Cache.getRealWorkspaceMember().get('role') === Constants.ADMIN ? true : false;
    };

    // is the logged in user a collaborator of the current workspace
    this.isCollaborator = function() {
        return Cache.getRealWorkspaceMember() && Cache.getRealWorkspaceMember().get('role') === Constants.ASSIGNEE ? true : false;
    };

    // is the logged in user a client of the current workspace
    this.isClient = function() {
        return Cache.getRealWorkspaceMember() && Cache.getRealWorkspaceMember().get('role') === Constants.CLIENT ? true : false;
    }

    this.isSuperAdmin = function() {
        return Cache.account.get('super_admin') === true && this.isWorkspaceAdmin(Cache.default_workspace_id);
    };

    this.isGenericHost = function() {
        return this.host === window.location.origin;
    },

    this.isFeedbackPortal= function() {
        return window.location.pathname.substring(0, 3) === '/p/';
    };

    // /viewer?a=x&p=x&k=x
    // /viewer/account_id/project_id/k/
    this.isFeedbackViewer = function() {
        return window.location.pathname.substring(0, 7) === '/viewer';
    };

    this.isSessionReplayShare = function() {
        return window.location.pathname.substring(0, 4) === '/sr/';
    };

    this.isExtCapture = function() {
        return window.location.pathname.substring(0, 8) === '/capture';
    };

    this.isDemoPage = function() {
        return window.location.pathname.endsWith('/demo');
    };

    this.isProjectPage = function(page) {
        const project_pages = ['dashboard', 'demo', 'feedback', 'response', 'integration'];

        if (page) {
            return project_pages.indexOf(page) !== -1;
        } else {
            const path = window.location.pathname.split('/');

            if (path.length >= 3) {
                return project_pages.indexOf(path[2]) !== -1;
            } else {
                return false;
            }
        }
    };

    this.isPublicPage = function() {
        if (this.isFeedbackPortal() || this.isFeedbackViewer() || this.isExtCapture() || this.isSessionReplayShare()) {
            return true;
        } else {
            return false;
        }
    },

    this.checkRoleAccess = function(access_type, role) {
        switch (access_type) {
            case Constants.ACCESS_WIDGET_SETTING:
            case Constants.ACCESS_SESSION_REPLAY:
                return role === Constants.ADMIN ? true : false;
            case Constants.ACCESS_PUBLIC_COMMENT:
                return true; // Admin, Collaborator, Client
            default:
                return false;
        }
    };

    this.getProjectsByUser = function(user_id) {
        var workspace_member = Cache.workspace_member.findWhere({user_id: user_id});

        var all_projects = Cache.project.where({is_archived: false});

        if (workspace_member) {
            if (workspace_member.get('role') === Constants.ADMIN) {
                return all_projects;
            } else {
                var my_projects = [];

                _.each(all_projects, function(project_model) {
                    if (Cache.project_access.findWhere({project_id: project_model.id, user_id: user_id})) {
                        my_projects.push(project_model);
                    }
                });

                return my_projects;
            }
        } else {
            return [];
        }
    };

    this.getUsersByProject = function(project_id, role, sort_by) {
        sort_by = sort_by || 'name';

        var users = [];

        if (Cache.account.hasFeature('user_restriction')) {
            // admin users
            Cache.workspace_member.where({is_disabled: false, role: Constants.ADMIN}).forEach((workspace_member) => {
                var user = Cache.user.get(workspace_member.get('user_id'));

                if (user) {
                    users.push(user);
                }
            });

            Cache.project_access.where({project_id: project_id}).forEach((model) => {
                var workspace_member = Cache.workspace_member.findWhere({user_id: model.get('user_id')});
                var user = Cache.user.get(model.get('user_id'));

                if (workspace_member && user && !workspace_member.get('is_disabled') && workspace_member.get('role') !== Constants.ADMIN) {
                    users.push(user);
                }
            });

        } else {
            Cache.workspace_member.where({is_disabled: false}).forEach((workspace_member) => {
                var user = Cache.user.get(workspace_member.get('user_id'));

                if (user) {
                    users.push(user);
                }
            });
        }

        if (typeof role !== 'undefined') {
            users = users.filter((user) => {
                var workspace_member = Cache.workspace_member.findWhere({user_id: user.id});

                if (role.indexOf(workspace_member.get('role')) !== -1) {
                    return true;
                } else {
                    return false;
                }
            });
        }

        if (sort_by === 'name') {
            users.sort((a, b) => {
                if (a.get(sort_by).toLowerCase() < b.get(sort_by).toLowerCase()) {
                    return -1;
                } else if (a.get(sort_by).toLowerCase() > b.get(sort_by).toLowerCase()) {
                    return 1
                } else {
                    return 0;
                }
            });
        }

        return users;
    };

    this.setTimeout = function(func, milliseconds, context) {
        func = context ? $.proxy(func, context) : func;

        return setTimeout(func, milliseconds);
    };
};

export default App;
